<button mat-button
        type="button"
        skip-disable
        disableRipple="true"
        class="ui-expandable-iconbutton"
        (click)="parent.expandableToggle()"
        [disabled]="parent.isAnimating">
  <mat-icon>{{parent.isExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
</button>
